<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-2">Création d'un code de réduction</div>
            <CodeReductionCreateForm v-if="loaded" :list_code_reduction="list_code_reduction"></CodeReductionCreateForm>

            <div class="text-h6 my-2">Liste des codes de réduction</div>
            <ListCodesReduction v-if="loaded" :list_code_reduction="list_code_reduction" @onUpdate="loadData" :key="key_reload"></ListCodesReduction>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CodeReductionCreateForm from "@/components/Administration/Code_Reduction/CodeReductionCreateForm.vue";
import ListCodesReduction from "@/components/Administration/Code_Reduction/ListCodesReduction.vue";
import List_Code_Reduction from "@/classes/Code_Reduction/List_Codes_Reduction.class";



export default {
  components: { CodeReductionCreateForm, ListCodesReduction },
  data() {
    return {
      key_reload: 0,
      loaded: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async loadData() {
      this.loaded = false;
      await this.list_code_reduction.fetch();
      
      this.loaded = true;
      this.key_reload++;

    },
  },
  async mounted() {
    this.list_code_reduction = new List_Code_Reduction(this.mainStore.module.id);
    await this.loadData();
  },
};
</script>

<style lang="scss" scoped></style>